import { render, staticRenderFns } from "./CountdownOverlay.vue?vue&type=template&id=3c61e598"
import script from "./CountdownOverlay.vue?vue&type=script&lang=js"
export * from "./CountdownOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports